import { render } from "./SlotMachinePage.vue?vue&type=template&id=0c45a180&scoped=true"
import script from "./SlotMachinePage.vue?vue&type=script&lang=js"
export * from "./SlotMachinePage.vue?vue&type=script&lang=js"

import "./SlotMachinePage.vue?vue&type=style&index=0&id=0c45a180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c45a180"]])

export default __exports__